export default __webpack_public_path__ + "static/media/users-team.f5168cae.svg";